import type { Competitor } from '../../domain/opportunity';
import { BASE_API_URL, HttpClient } from '../../services/HttpClient';

export const competitorsApi = {
  searchCompetitors: (searchTerm: string) => {
    const params = new URLSearchParams({ prefix: searchTerm });
    return HttpClient.get<{ name: string; companyName?: string }[]>(
      `${BASE_API_URL}/competitors/search?${params.toString()}`
    );
  },
  getCompetitors: (prospect: string) => {
    return HttpClient.get<Competitor[]>(`${BASE_API_URL}/competitors/${prospect}`);
  },
  updateCompetitors: (prospect: string, competitorDomains: string[]) => {
    return HttpClient.put(`${BASE_API_URL}/competitors/${prospect}`, { competitorDomains });
  },
};
